import { getAppImageData } from '@components/appImage';
import { PageSection } from '@components/pageSection';

import { CasesSlider } from './CasesSlider';

import { getDataPage } from '@/app/getDataPage';
import { GetCasesResponse } from '@/shared/api/getCases';
import { Locale, TranslationBlocks } from '@/shared/types';
import { formatCasesItems, translateCasesItems } from '@/shared/utils/cases';
import prepareTranslations from '@/shared/utils/prepareTranslations';

/** Ширина картинки кейса: слайд на десктопе ~470px, на планшете и уже — вся ширина */
const CASE_CARD_IMAGE_SIZES = '(max-width: 1024px) 100vw, 470px';
/** 656x800, рендер по ширине слайда 470 */
const ALL_CASES_BG_SIZE = { width: 470, height: 573 };

interface CasesProps {
  title?: string;
  link?: string;
  allCasesCardText?: string;
  items: GetCasesResponse['items'];
  allCasesButtonText?: string;
  withoutAllCasesCard?: boolean;
  locale?: Locale;
}

export const Cases = async ({
  title = 'Как решения 2ГИС помогают нашим клиентам',
  link = '/cases',
  allCasesCardText = 'Больше кейсов',
  items,
  allCasesButtonText,
  withoutAllCasesCard = true,
  locale = 'ru',
}: CasesProps) => {
  const casesTranslationsResponse = await getDataPage(
    TranslationBlocks.Cases,
    locale,
    { includeCommon: true },
  );
  const casesTranslations = prepareTranslations(
    casesTranslationsResponse.items,
  );
  const translatedItems = translateCasesItems(items, casesTranslations);
  const formattedCasesItems = formatCasesItems(translatedItems);

  const casesWithImages = await Promise.all(
    formattedCasesItems.map(async (el) => ({
      ...el,
      imageData: await getAppImageData(el.img, {
        fill: true,
        sizes: CASE_CARD_IMAGE_SIZES,
      }),
    })),
  );

  const allCasesBgData = await getAppImageData(
    '/images/cases-card-bg.png',
    ALL_CASES_BG_SIZE,
  );

  return (
    <PageSection>
      <CasesSlider
        title={title}
        link={link}
        articlesCards={casesWithImages}
        allCasesCardText={allCasesCardText}
        allCasesButtonText={allCasesButtonText}
        allCasesBgData={allCasesBgData}
        withoutAllCasesCard={withoutAllCasesCard}
        halfPageSliderOverlayUrl="/images/cases-slider-overlay.png"
      />
    </PageSection>
  );
};
